import { gql } from '@apollo/client';

export default gql`
  mutation processLoyaltyPrrRefund(
    $bookingReference: String!
    $refundAmount: Float!
    $membershipNumber: String!
    $username: String!
    $additionalDetails: [InputAdditionalDetails!]!
    $compensationRecordsToUpdate: [InputCompensationRecordToUpdate]
  ) {
    processLoyaltyPrrRefund(
      bookingReference: $bookingReference
      refundAmount: $refundAmount
      membershipNumber: $membershipNumber
      username: $username
      additionalDetails: $additionalDetails
      compensationRecordsToUpdate: $compensationRecordsToUpdate
    ) {
      bookingReference
      membershipNumber
      updatedCompensationRecords
    }
  }
`;
